type Difficulty = {
	uuid: string;
	label: string;
	value: string;
};

export const difficulties: Difficulty[] = [
	{
		uuid: "9ed8e54e-3406-4ba3-a7af-90197c9f5d3d",
		label: "Easy",
		value: "EASY",
	},
	{
		uuid: "9ed8e54e-341a-4614-8bd3-7e77aa544489",
		label: "Medium",
		value: "MEDIUM",
	},
	{
		uuid: "9ed8e54e-3420-4201-b876-7cf761ce35e5",
		label: "Hard",
		value: "HARD",
	},
];
